import { atom } from 'jotai'

// 현재 정책 상 Popover는 최대 하나만 열리도록 되어있다.
// 우선 계산기 페이지와 암 용어사전 Popover에만 적용한다.
// 다른 팝오버가 열리면 공유 넛지 팝오버를 숨겨야한다.
export const INITIAL_POPOVER_OPENED = false

export const isPopoverOpenedAtom = atom<boolean>(INITIAL_POPOVER_OPENED)
